<div class="modal-content pb-3">
  <!--Header-->
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
  >
    <div class="modal-title">
      <h4 class="mb-0">Drivers License Selection</h4>
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeComponent()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <ag-grid-angular
    id="dispo_list"
    class="modern-grid"
    style="width: 98%; height: 40vh; margin: 10px auto 0 auto; display: block"
    
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [rowData]="sharedService.recent_drivers_license"
    [animateRows]="true"
    [rowSelection]="rowSelection"
    [components]="components"
    [enableBrowserTooltips]="true"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
